import { createSlice } from '@reduxjs/toolkit';
import { fetchNetworks } from '../networks/networksSlice';
import { callPreTransfer, payWithPayPal, payWithCreditCard } from '../transfer/transferSlice';
import { sendSmsToSender, verifyCode, resendSmsCode } from '../sender/senderSlice';

const initialState = {
  loadingText: '',
  isLoading: false,
};

const startLoading = (text) => (state) => {
  state.loadingText = text;
  state.isLoading = true;
};

const stopLoading = () => (state) => {
  state.loadingText = '';
  state.isLoading = false;
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loadingText = action.payload.text || '';
      state.isLoading = action.payload.isLoading;
    },
  },
  extraReducers: {
    [fetchNetworks.pending]: startLoading('Fetching carriers...'),
    [fetchNetworks.fulfilled]: stopLoading(),
    [fetchNetworks.rejected]: stopLoading(),

    [callPreTransfer.rejected]: stopLoading(),
    [callPreTransfer.fulfilled]: stopLoading(),
    [callPreTransfer.pending]: startLoading('Setting PayPal payment...'),

    [payWithPayPal.rejected]: stopLoading(),
    [payWithPayPal.fulfilled]: stopLoading(),
    [payWithPayPal.pending]: startLoading('PayPal payment in process...'),

    [payWithCreditCard.rejected]: stopLoading(),
    [payWithCreditCard.fulfilled]: stopLoading(),
    [payWithCreditCard.pending]: startLoading('Payment in process...'),

    [sendSmsToSender.rejected]: stopLoading(),
    [sendSmsToSender.fulfilled]: stopLoading(),
    [sendSmsToSender.pending]: startLoading('Loading, please wait...'),

    // [verifyCode.rejected]: stopLoading(),
    // [verifyCode.fulfilled]: stopLoading(),
    [verifyCode.pending]: startLoading('Loading, please wait...'),

    [resendSmsCode.rejected]: stopLoading(),
    [resendSmsCode.fulfilled]: stopLoading(),
    [resendSmsCode.pending]: startLoading('Loading, please wait...'),
  },
});

export const { setLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
